import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { CreateEventDto } from '@/types/dtos/events/request/create-event.dto.ts';
import type { EventDto } from '@/types/dtos/events/response/event.dto.ts';
import { GET_EVENTS_QUERY_KEY } from '../../queries/events/use-events.ts';

export const useCreateEventMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (newEvent: CreateEventDto) => {
      const token = await getToken();
      return createEvent(newEvent, token ?? '');
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: [GET_EVENTS_QUERY_KEY],
      });
    },
  });
};

const createEvent = async (newContent: CreateEventDto, token: string): Promise<EventDto> => {
  const url = `${import.meta.env.VITE_API_URL}/events`;
  return sendJSONRequest({ url, method: METHOD.POST, body: newContent, token });
};

export default useCreateEventMutation;
